import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { TrainStation } from "@core/models/trainStation";
import { CompanyService, TrainService, UserService } from "@core/services";
import { GroupService } from "@core/services/group.service";
import { NgxToastrService } from "@core/services/ngx.toastr.service";
import { ProvidersService, ProviderType } from "@core/services/providers.service";
import { TravelUtilsService } from "@core/services/travel-utils.service";
import { UtilsService } from "@core/services/utils.service";
import { Company, User } from "@models";
import {
  NgbActiveModal,
  NgbDateParserFormatter,
  NgbModal,
  NgbTypeahead,
} from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { UserCardModalComponent } from "@shared/component/user-card-modal/user-card-modal.component";
import { AppState } from "app/app.reducer";
import cities from "assets/utils/cities.json";
import * as moment from "moment";
import { take } from "rxjs";

@Component({
  selector: "app-create-flight-train",
  templateUrl: "./create-flight-train.component.html",
  styleUrls: ["./create-flight-train.component.scss"],
})
export class CreateFlightTrainComponent implements OnInit {
  @Input() isAdmin;
  @Input() type: "flight" | "train";
  @Input() loading: Boolean;
  @Input() companyUuid: string;
  @Input() userId: string;
  @Output() sendInfo = new EventEmitter<any>();
  editing = false;
  @Input() data;
  request: any;
  @Input() blobUrl;
  @Input() fileBack;
  userType: any;

  @ViewChild("instanceUsers") instanceUsers: NgbTypeahead;

  form: UntypedFormGroup;
  prefOptions = [];
  users: User[] = [];
  file: File;
  user: User;
  citiesList = [];
  date = new Date();
  minDateNgStruct = {
    year: this.date.getFullYear() - 1,
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  maxDateNgStruct = {
    year: this.date.getFullYear() + 20,
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  checkedOneWay = false;
  checkedReturn = true;
  bodyTravel: any = {};
  isInvalid: boolean = false;
  companyUsers: { name: string; lastname: string; uuid: string }[] = [];
  files: File[] = [];
  filesToRemove: any[] = [];
  existingFiles: any[] = [];
  company: Company;
  filteredUsers: { name: string; lastname: string; uuid: string }[] = [];
  filteredUsersWithoutDefault: { name: string; lastname: string; uuid: string }[] = [];
  @Input() defaultUser: any;
  isCustom: boolean = false;
  trainStationList: TrainStation[] = []
  filteredStationList: any = [];
  origin: TrainStation;
  destination: TrainStation;
  providerOptionsMap: Record<'flight' | 'train', string[]> = { flight: [], train: [] };
  private providerDocsMap: Record<'flight' | 'train', any[]> = {
    flight: [],
    train: [],
  };
  loadingProviders = false;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    public translate: TranslateService,
    private groupService: GroupService,
    private ngxToastrService: NgxToastrService,
    private ngbDateParser: NgbDateParserFormatter,
    private travelUtilsService: TravelUtilsService,
    private utilsService: UtilsService,
    private userService: UserService,
    private store: Store<AppState>,
    private companyService: CompanyService,
    private modalService: NgbModal,
    private trainService: TrainService,
    private providersService: ProvidersService,
  ) { }

  ngOnInit() {
    if (this.type === "train") {
      this.getTrainStations()
    }
    if (this.fileBack) {
      this.existingFiles = Array.isArray(this.fileBack) ? this.fileBack : [this.fileBack];
    }
    if (Array.isArray(this.files[0])) {
      this.files = this.files.reduce((acc, val) => acc.concat(val), []);
    }

    this.data && this.data !== null
      ? (this.editing = true)
      : (this.editing = false);
    if(this.type === "flight" && !this.data?.lleegoReservationUuid){
      this.isCustom = true;
    }
    this.translate
      .get([
        `${this.type?.toLowerCase()}.form-${this.type?.toLowerCase()}.anyone`,
        `${this.type?.toLowerCase()}.form-${this.type?.toLowerCase()}.morning`,
        `${this.type?.toLowerCase()}.form-${this.type?.toLowerCase()}.afternoon`,
        `${this.type?.toLowerCase()}.form-${this.type?.toLowerCase()}.night`,
      ])
      .subscribe((result) => {
        this.prefOptions = [
          {
            value: "anyone",
            text: result[`${this.type?.toLowerCase()}.form-${this.type?.toLowerCase()}.anyone`],
          },
          {
            value: "morning",
            text: result[`${this.type?.toLowerCase()}.form-${this.type?.toLowerCase()}.morning`],
          },
          {
            value: "evening",
            text: result[`${this.type?.toLowerCase()}.form-${this.type?.toLowerCase()}.afternoon`],
          },
          {
            value: "noon",
            text: result[`${this.type?.toLowerCase()}.form-${this.type?.toLowerCase()}.night`],
          },
        ];
      });
    this.checkedOneWay = (this.data?.oneWay === true) || (this.request?.oneWay === true);
    this.checkedReturn = this.checkedOneWay ? false : true;
    if (this.userId) {
      this.userService
        .getUser(this.userId)
        .pipe(take(1))
        .subscribe((user: User) => {
          this.user = user;
          if(!this.editing){
            this.defaultUser = {
              name: this.user.name,
              lastname: this.user.lastname,
              uuid: this.user.uuid
            };
            this.updateTravellers();
          }
          if (this.user?.companyUuid) {
            this.companyService.getCompany(this.user.companyUuid).subscribe(
              (company: Company) => {
                this.company = company;
              },
              (error) => {}
            );
          }
        });
    }
    this.store
    .select("auth")
    .pipe(take(1))
    .subscribe((res) => {
      if (res.isAuthenticated) {
        this.userType = res.user.type;
      }
    });

    // Inicializo el formulario
    this.form = this.formBuilder.group({
      file: [
        this.editing ? this.data.file : null,
        this.fileBack && this.blobUrl ? [] : [],
      ],
      origin: [
        { value: this.editing ? (this.data.origin?.name ? this.data.origin?.name : this.data.from) : this.request ? this.request.from : '', disabled: this.userType != "EMPLOYEE"},
        [Validators.required],
      ],
      destination: [
        { value: this.editing ? (this.data.destination?.name ? this.data.destination?.name : this.data.to) : this.request ? this.request.to : '', disabled: this.userType != "EMPLOYEE" },
        [Validators.required],
      ],
      dateDeparture: [
        this.editing
          ? this.ngbDateParser.parse(
            moment(this.data.outwardDate.departDate ? this.data.outwardDate.departDate : this.data.departDate).toString()
          )
          : '',
        [Validators.required],
      ],
      dateReturn: [
        this.editing && this.data.returnDate
          ? this.ngbDateParser.parse(
            moment(this.data.returnDate.departDate ? this.data.returnDate.departDate : this.data.returnDate).toString()
          )
          : null,
      ],
      timeDeparture: [
        { value: this.editing
          ? {
            hour: new Date(this.data.outwardDate.departDate ? this.data.outwardDate.departDate : this.data.departDate).getHours(),
            minute: new Date(this.data.outwardDate.departDate ? this.data.outwardDate.departDate : this.data.departDate).getMinutes(),
          }
          : '', disabled: this.userType != "EMPLOYEE" },
        [Validators.required],
      ],
      timeReturn: [
       { value: this.editing && this.data.returnDate
          ? {
            hour: new Date(this.data.returnDate.departDate ? this.data.returnDate.departDate : this.data.returnDate).getHours(),
            minute: new Date(this.data.returnDate.departDate ? this.data.returnDate.departDate : this.data.returnDate).getMinutes(),
          }
          : '', disabled: this.userType != "EMPLOYEE"}
      ],
      notes: [{ value: this.editing ? this.data.observations : "", disabled: this.userType != "EMPLOYEE" }],
      price: this.editing
          ? [
              {
                value: this.type === "flight"
                        ? (typeof this.data.price.individualPrice === 'number'
                            ? this.data.price.individualPrice
                            : this.data.price
                          ).toFixed(2)
                        : (this.data.price.total ? this.data.price.total : this.data.price),
                disabled: this.data?.payment || this.data?.refund || this.userType !== 'EMPLOYEE',
              },
              [Validators.required],
            ]
          : [
              {
                value: null,
                disabled: true,
              },
              [Validators.required],
            ],
      
      freeTaxes: [
        { value: this.editing && this.data !== null && this.data.freeTaxes
          ? this.data.freeTaxes
          : false, disabled: this.userType != "EMPLOYEE" },
        [Validators.required],
      ],
      customCode: [
        this.editing
          ? this.data.customCode != null
            ? this.data.customCode
            : null
          : '',
      ],
      costCenter: [
        this.editing
          ? this.data.costCenter != null
            ? this.data.costCenter
            : null
          : '',
      ],
      supplierInvoice: [
        {
        value: this.editing ? (this.data?.supplierInvoice ?? '') : (this.request?.supplierInvoice ?? ''),
        disabled: this.userType !== 'EMPLOYEE' 
        }
      ],
      bookType: [
        {
          value: this.editing ? (this.data?.bookType ?? '') : '',
          disabled: this.userType !== 'EMPLOYEE'
        }
      ],
      invoiced: [
        {
          value: this.editing ? (this.data?.invoiced ?? 'none') : 'none',
          disabled: this.userType !== 'EMPLOYEE'
        }
      ],
    });
    
    if (this.editing) {
      this.form.addControl('wholesalePrice', new FormControl(
        {
          value: typeof this.data?.wholesalePrice === 'number'
            ? this.data.wholesalePrice.toFixed(2)
            : (this.data?.wholesalePrice || ''),
          disabled: this.data?.payment || this.data?.refund || this.userType !== 'EMPLOYEE'
        }
      ));
      const legsOut = this.buildLegsFromScales('outbound');
      const legsRet = !this.checkedOneWay ? this.buildLegsFromScales('return') : [];

      const outFA = this.formBuilder.array(
        legsOut.map(l => this.formBuilder.group({
          segment:   [l.segment],
          departure: [l.departure],
          arrival:   [l.arrival],
          type:      [l.type],
          seat:      [this.preloadSeatForLeg(l)]
        }))
      );

      const retFA = this.formBuilder.array(
        legsRet.map(l => this.formBuilder.group({
          segment:   [l.segment],
          departure: [l.departure],
          arrival:   [l.arrival],
          type:      [l.type],
          seat:      [this.preloadSeatForLeg(l)]
        }))
      );

      this.form.addControl('outboundLegs', outFA);
      this.form.addControl('returnLegs', retFA);

      if (this.checkedOneWay) {
        (this.form.get('returnLegs') as FormArray)?.clear();
      }
    }

    if (this.type === 'flight' && this.isCustom) {
      this.form.addControl(
        'departureAirline',
        new FormControl({
          value: this.editing && Array.isArray(this.data?.airlines) ? this.data.airlines[0] || '' : '',
          disabled: this.userType !== 'EMPLOYEE',
        })
      );
    
      this.form.addControl(
        'returnAirline',
        new FormControl({
          value: this.editing && Array.isArray(this.data?.airlines) ? this.data.airlines[1] || '' : '',
          disabled: this.checkedOneWay || this.userType !== 'EMPLOYEE',
        })
      );

      const prevSeats: Array<{ seat?: string; segment?: string; departure?: string; arrival?: string }> =
        (this.data?.extraInfo?.[0]?.seats ?? []) as any[];

      const outboundList = prevSeats
        .filter(s => (s?.segment || '').toLowerCase() === 'outbound' 
                  || s?.departure === this.form.get('origin')?.value)
        .map(s => s?.seat)
        .filter(Boolean);

      const returnList = prevSeats
        .filter(s => (s?.segment || '').toLowerCase() === 'return' 
                  || s?.departure === this.form.get('destination')?.value)
        .map(s => s?.seat)
        .filter(Boolean);


      this.form.addControl(
        'seatsOutbound',
        new FormControl({
          value: outboundList.join(', '),
          disabled: this.userType !== 'EMPLOYEE',
        })
      );

      this.form.addControl(
        'provider',
        new FormControl({
          value: this.editing ? this.data.provider != null ? this.normalizeProvider(this.data?.provider) : null : '',
          disabled: this.userType !== 'EMPLOYEE',
         })
      );
      this.form.addControl(
        'seatsReturn',
        new FormControl({
          value: returnList.join(', '),
          disabled: this.checkedOneWay || this.userType !== 'EMPLOYEE',
        })
      );

      if (this.editing) {
        this.form.addControl(
          'class',
          new FormControl({
            value: this.data?.class || '',
            disabled: this.userType !== 'EMPLOYEE',
          })
        );
      }
    }

    if (this.type === 'flight') {
      this.form.addControl(
        'pnr',
        new FormControl({
          value: this.editing && this.data !== null && this.data.pnr ? this.data.pnr : "",
          disabled: this.userType !== "EMPLOYEE",
        })
      );
    }

    if (this.type === 'train') {
      this.form.addControl(
        'seats',
        new FormControl({
          value: this.editing && Array.isArray(this.data?.extraInfo?.[0]?.seats)
            ? this.data?.extraInfo?.[0]?.seats?.map(s => s?.seat || '').filter(s => s !== '').join(', ')
            : '',
          disabled: this.userType !== 'EMPLOYEE',
        })
      );
      
      this.form.addControl(
        'pnr',
        new FormControl({
          value: this.editing && this.data !== null && this.data.locator ? this.data.locator : "",
          disabled: this.userType !== "EMPLOYEE",
        })
      );

      this.form.addControl(
        'departureCarrier',
        new FormControl({
          value: this.editing && Array.isArray(this.data?.carriers) ? this.data.carriers[0] || '' : '',
          disabled: this.userType !== 'EMPLOYEE',
        })
      );
    
      this.form.addControl(
        'returnCarrier',
        new FormControl({
          value: this.editing && Array.isArray(this.data?.carriers) ? this.data.carriers[1] || '' : '',
          disabled: this.checkedOneWay || this.userType !== 'EMPLOYEE',
        })
      );

      this.form.addControl(
        'provider',
        new FormControl({
          value: this.editing ? this.data.provider != null ? this.normalizeProvider(this.data?.provider) : null : '',
          disabled: this.userType !== 'EMPLOYEE',
        })
      );

      if (this.editing) {
        this.form.addControl(
          'class',
          new FormControl({
            value: this.data?.class || '',
            disabled: this.userType !== 'EMPLOYEE',
          })
        );
      }
    }

    if (this.editing) {
      const initialProvider = (this.data?.provider ?? '').toString().trim();
      if (!this.form.get('provider')) {
        this.form.addControl(
          'provider',
          new FormControl({
            value: initialProvider,
            disabled: this.userType !== 'EMPLOYEE',
          })
        );
      } else {
        this.form.get('provider')!.setValue(initialProvider);
      }
    }

    this.loadProvidersForType(this.type);
    
    if(!this.editing){
      this.form.addControl('travellersCount', new FormControl(1, [Validators.required]));
      this.form.addControl('travellers', new FormArray([]));
      this.updateTravellers();
    }
    const validator = this.checkedOneWay ? null : [Validators.required];
    this.form.get("dateReturn").setValidators(validator);
    this.form.get("timeReturn").setValidators(validator);
    this.form.get("dateReturn").updateValueAndValidity();
    this.form.get("timeReturn").updateValueAndValidity();

    if (this.editing) {
      this.form.addControl('passenger', new FormControl({ value: this.data ? this.data.userUuid : '', disabled: !(this.userType?.toLowerCase() === 'employee' || this.userType?.toLowerCase() === 'company') }));
    }

    if (this.form.value.dateDeparture) {
      this.form.patchValue({ dateDeparture: { day: this.form.value.dateDeparture.day, month: this.form.value.dateDeparture.month + 1, year: this.form.value.dateDeparture.year } })
    }
    if (this.form.value.dateReturn) {
      this.form.patchValue({ dateReturn: { day: this.form.value.dateReturn.day, month: this.form.value.dateReturn.month + 1, year: this.form.value.dateReturn.year } })
    }

    
    if (this.request) {
      if (!this.editing) {
        this.form.patchValue({
          customCode: this.request.customCode ?? '',
          costCenter: this.request.costCenter ?? ''
        });
      }
      this.request.initDate = moment(this.request.initDate).format(
        "DD/MM/YYYY HH:mm"
      );
      const valueInit = {
        year: this.request.initDate.split("/")[2].split(" ")[0] * 1,
        month: this.request.initDate.split("/")[1] * 1,
        day: this.request.initDate.split("/")[0] * 1,
      };
      this.form.patchValue({ dateDeparture: valueInit });
      const timeInit = {
        hour:
          this.request.initDate
            .toString()
            .split("/")[2]
            .split(" ")[1]
            .split(":")[0] * 1,
        minute:
          this.request.initDate
            .toString()
            .split("/")[2]
            .split(" ")[1]
            .split(":")[1] * 1,
      };
      this.form.patchValue({ timeDeparture: timeInit });
      if (this.request.endDate) {
        this.request.endDate = moment(this.request.endDate).format(
          "DD/MM/YYYY HH:mm"
        );
        const valueEnd = {
          year: this.request.endDate.split("/")[2].split(" ")[0] * 1,
          month: this.request.endDate.split("/")[1] * 1,
          day: this.request.endDate.split("/")[0] * 1,
        };
        this.form.patchValue({ dateReturn: valueEnd });
        const timeEnd = {
          hour:
            this.request.endDate
              .toString()
              .split("/")[2]
              .split(" ")[1]
              .split(":")[0] * 1,
          minute:
            this.request.endDate
              .toString()
              .split("/")[2]
              .split(" ")[1]
              .split(":")[1] * 1,
        };
        this.form.patchValue({ timeReturn: timeEnd });
      }
      this.checkedOneWay = this.request ? this.request.oneWay === true : false;
      this.checkedReturn = this.request ? this.request.oneWay === false : false;
    }
    // Cargo los empleados de la compañia
    if (!this.userId) {
      this.form.addControl(
        "userId",
        new UntypedFormControl(null, [Validators.required])
      );
      this.loadGroups(this.companyUuid);
    }

    if(this.editing && this.utilsService.isAdmin(this.userType?.toLowerCase())){
      this.getCompanyUsers(true);
    }
    if(!this.editing && this.userType === "EMPLOYEE"){
      this.getCompanyUsers();
    }
  }
  get f() {
    return this.form.controls;
  }

  getTrainStations() {
    this.trainService.getStations().subscribe((res: TrainStation[]) => {
      this.trainStationList = res;
    })
  }

  getStations(value: string) {
    this.filteredStationList = [];
    if (value !== "" && value.length > 2) {
      this.trainStationList.forEach((e) => {
        if (
          (e.name &&
            (e.name.includes(value) ||
              e.name
                ?.toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(
                  value
                    ?.toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                )))
        ) {
          this.filteredStationList.push(e);
        }
      });
      this.trainStationList.forEach((e) => {
        if (
          e.name.includes(value) ||
          e.name?.toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(
              value
                ?.toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
            )
        ) {
          if (
            !this.filteredStationList.some((f) =>
              f.name?.toLowerCase().includes(`${value?.toLowerCase()}`)
            )
          ) {
            this.filteredStationList.push(e);
          }
        }
      });
    } else {
      this.filteredStationList = [];
    }
  }

  departureBeforeReturn(dateDepartureAux, dateReturnAux) {
    return this.utilsService.departureBeforeReturn(
      dateDepartureAux,
      dateReturnAux,
      this.f
    );
  }

  onSubmit() {
    if (!this.editing) {
      this.showPaymentCardSelector().then((selectedCard) => {
        if (!selectedCard && !this.company.bookedWithoutCard) {
          this.loading = false;
          return;
        }
  
        this.processBookingForm(selectedCard);
      });
    } else {
      this.processBookingForm();
    }
  }

  optionSelected(field: string, value: string) {
    if (this.trainStationList.length > 0) {
      if (field === "origin") {
        this.origin = this.trainStationList.find(
          (a) => a.name === value
        );
      }
      if (field === "destination") {
        this.destination = this.trainStationList.find(
          (a) => a.name === value
        );
      }
    }
  }
  
  processBookingForm(selectedCard?: any) {
    this.isInvalid = false
    const travel = this.travelUtilsService.getTravelLocalStorage();
    const dateDepartureAux = moment(
      this.ngbDateParser.format(this.f.dateDeparture.value),
      "DD/MM/YYYY"
    ).format("YYYY-MM-DD");
    const dateReturnAux = moment(
      this.ngbDateParser.format(this.f.dateReturn.value),
      "DD/MM/YYYY"
    ).format("YYYY-MM-DD");
    if (this.departureBeforeReturn(dateDepartureAux, dateReturnAux)) {
      if (
        !moment(this.f.dateReturn.value).isBefore(
          moment(this.f.dateDeparture.value)
        )
      ) {
        if (!this.userId && !this.f.userId.value) {
          this.translate
            .get([
              "common.error",
              `${this.type?.toLowerCase()}.create-${this.type?.toLowerCase()}.error-employee`,
            ])
            .subscribe((resp) => {
              this.ngxToastrService.typeInfo(
                resp["common.error"],
                resp[`${this.type?.toLowerCase()}.create-${this.type?.toLowerCase()}.error-employee`]
              );
            });
        } else {
          if (this.fileBack) {
            delete this.fileBack.name;
          }
          const req: any = {
            userId: this.userId ? this.userId : this.f.userId.value.uuid,
            companyUuid: this.companyUuid,
            filesToRemove: this.filesToRemove,
            origin: this.origin ?? this.f.origin.value,
            destination: this.destination ?? this.f.destination.value,
            departure: moment(
              dateDepartureAux +
              " " +
              (
                "0" +
                (this.f.timeDeparture.value
                  ? this.f.timeDeparture.value.hour
                  : "00")
              ).slice(-2) +
              ":" +
              (
                "0" +
                (this.f.timeDeparture.value
                  ? this.f.timeDeparture.value.minute
                  : "00")
              ).slice(-2)
            ),
            annotations: this.f.notes.value || '',
            pnr: this.f.pnr.value,
            oneWay: this.checkedOneWay,
            customCode: this.f.customCode.value,
            costCenter: this.f.costCenter.value,
            supplierInvoice: this.f.supplierInvoice.value,
            bookType: this.f.bookType.value || '',
            invoiced: this.f.invoiced?.value || 'none',
          };

          if(this.editing){
            req.file = this.files.length > 0 ? this.files : [];
            req.price = parseFloat(this.f.price.value.toString().replace(",", ".")).toFixed(2);
            if (this.form.get('wholesalePrice')?.value !== undefined && this.form.get('wholesalePrice')?.value !== '') {
              req.wholesalePrice = parseFloat(this.form.get('wholesalePrice')!.value.toString().replace(",", ".")).toFixed(2);
            }
            req.freeTaxes = this.f.freeTaxes.value;
            const providerName = this.form.get('provider')?.value;
            const providerUuid = this.resolveProviderUuidByName(providerName);

            if (providerUuid) {
              req.providerUuid = providerUuid;
            }
          }

          if (!this.editing) {
            const travellersArray = this.form.get('travellers') as FormArray;

            if (this.type === 'flight') {
              const origin = this.form.get('origin')?.value || '';
              const destination = this.form.get('destination')?.value || '';
              const outSegment: 'outbound' = 'outbound';
              const retSegment: 'return' = 'return';

              req.travellers = travellersArray.controls.map((group: AbstractControl) => {
                const outSeats = this.buildSeatObjects(
                  this.parseSeats(group.get('seatOutbound')?.value),
                  outSegment, origin, destination
                );
                const retSeats = this.checkedOneWay ? [] : this.buildSeatObjects(
                  this.parseSeats(group.get('seatReturn')?.value),
                  retSegment, destination, origin
                );

                const providerName = group.get('provider')?.value;
                const providerUuid = this.resolveProviderUuidByName(providerName);

                return {
                  uuid: group.get('uuid')?.value?.uuid || group.get('uuid')?.value,
                  price: parseFloat(group.get('price')?.value.toString().replace(",", ".")),
                  wholesalePrice: parseFloat(group.get('wholesalePrice').value.toString().replace(",", ".")),
                  files: group.get('files')?.value,
                  class: group.get('class')?.value,
                  extras: group.get('extras')?.value,
                  freeTaxes: group.get('freeTaxes')?.value,
                  seat: [...outSeats, ...retSeats],
                  providerUuid,
                };
              });

            } else if (this.type === 'train') {
              const origin = this.form.get('origin')?.value || '';
              const destination = this.form.get('destination')?.value || '';
              const outSegment: 'outbound' = 'outbound';
              const retSegment: 'return'   = 'return';

              req.travellers = travellersArray.controls.map((group: AbstractControl) => {
                const outSeats = this.buildSeatObjects(
                  this.parseSeats(group.get('seatOutbound')?.value),
                  outSegment, origin, destination
                );
                const retSeats = this.checkedOneWay ? [] : this.buildSeatObjects(
                  this.parseSeats(group.get('seatReturn')?.value),
                  retSegment, destination, origin
                );

                const providerName = group.get('provider')?.value;
                const providerUuid = this.resolveProviderUuidByName(providerName);

                return {
                  uuid: group.get('uuid')?.value?.uuid || group.get('uuid')?.value,
                  price: parseFloat(group.get('price')?.value.toString().replace(",", ".")),
                  wholesalePrice: parseFloat(group.get('wholesalePrice').value.toString().replace(",", ".")),
                  files: group.get('files')?.value,
                  class: group.get('class')?.value,
                  extras: group.get('extras')?.value,
                  freeTaxes: group.get('freeTaxes')?.value,
                  seat: [...outSeats, ...retSeats],
                  providerUuid
                };
              });
            }
          }

          if (this.type === 'flight' && this.isCustom) {
            req.departureAirline = this.form.get('departureAirline').value;
            if (!this.checkedOneWay) {
              req.returnAirline = this.form.get('returnAirline').value;
            }
            if(this.editing){
              req.class = this.form.get('class').value;
            }
          }

          if (this.editing && this.type === 'flight') {
            const outLegs = (this.form.get('outboundLegs') as FormArray)?.value || [];
            const retLegs = (this.form.get('returnLegs') as FormArray)?.value || [];

            const legs = [...outLegs, ...retLegs]
              .filter(l => (l.seat || '').trim() !== '');

            const seatsPayload = legs.map(l => ({
              seat: (l.seat || '').trim(),
              segment: (l.segment && String(l.segment).trim()) || '',
              departure: l.departure,
              arrival: l.arrival,
              type: l.type,
            }));

            req.seats = seatsPayload;
          }

          if (this.editing && this.type === 'train') {
            const outLegs = (this.form.get('outboundLegs') as FormArray)?.value || [];
            const retLegs = (this.form.get('returnLegs') as FormArray)?.value || [];

            const legs = [...outLegs, ...retLegs]
              .filter(l => (l.seat || '').trim() !== '');

            const seatsPayload = legs.map(l => ({
              seat: (l.seat || '').trim(),
              departure: l.departure,
              arrival: l.arrival,
              type: l.type,
            }));

            req.seats = seatsPayload;
          }

          if (this.type === 'train') {
            req.departureCarrier = this.form.get('departureCarrier').value;
            if (!this.checkedOneWay) {
              req.returnCarrier = this.form.get('returnCarrier').value;
            }
            if(this.editing){
              req.class = this.form.get('class').value;
            }
          }
          if (this.editing && this.data?.price?.individualPrice != null) {
            req["originalAmount"] = this.data.price.individualPrice;
          }
          if(this.editing && this.data?.price){
            req["totalPrice"] = this.data.price?.totalPrice || 0;
          }
          if(this.editing && this.data?.relatedFlights){
            req["relatedFlights"] = this.data.relatedFlights;
          }
          if (!this.checkedOneWay) {
            req.return = moment(
              dateReturnAux +
              " " +
              (
                "0" +
                (this.f.timeReturn.value
                  ? this.f.timeReturn.value.hour
                  : "00")
              ).slice(-2) +
              ":" +
              (
                "0" +
                (this.f.timeReturn.value
                  ? this.f.timeReturn.value.minute
                  : "00")
              ).slice(-2)
            );
          }
          if (travel && travel.data.title) {
            req["travelName"] = travel.data.title;
          }

          if(this.editing){
            req["passenger"] = this.f.passenger.value;
          }

          if (this.request?.traveller) {
            req["traveller"] = this.request.traveller;
          } else if (this.user) {
            let traveller = []
            switch (this.type?.toLowerCase()) {
              case 'flight':
                traveller.push({ name: `${this.user.name} ${this.user.lastname}` });
                req["traveller"] = traveller;
                break;
              case 'train':
                traveller.push({ name: `${this.user.name} ${this.user.lastname}`, renfeCard: this.user.renfeCard ?? null })
                req["traveller"] = traveller;
                break;
            }
          }
          if (selectedCard) {
            req["paymentCard"] = {
              name: selectedCard.name,
              token: selectedCard.token,
            };
          }
          this.sendInfo.emit(req);
        }
      } else {
        this.translate
          .get(["common.error", `${this.type?.toLowerCase()}.create-${this.type?.toLowerCase()}.error-dates`])
          .subscribe((resp) => {
            this.ngxToastrService.typeInfo(
              resp["common.error"],
              resp[`${this.type?.toLowerCase()}.create-${this.type?.toLowerCase()}.error-dates`]
            );
          });
      }
    } else {
      this.translate
        .get(["common.error", `${this.type?.toLowerCase()}.create-${this.type?.toLowerCase()}.error-dates`])
        .subscribe((resp) => {
          this.ngxToastrService.typeInfo(
            resp["common.error"],
            resp[`${this.type?.toLowerCase()}.create-${this.type?.toLowerCase()}.error-dates`]
          );
        });
    }
  }

  showPaymentCardSelector(): Promise<any> {
    if (this.company.bookedWithoutCard) {
      return Promise.resolve(null);
    }

    if (!Array.isArray(this.user.paymentCards)) {
      this.user.paymentCards = this.user.paymentCards ? [this.user.paymentCards] : [];
    }

    /* if (!Array.isArray(this.user.personalPaymentCards)) {
      this.user.personalPaymentCards = this.user.personalPaymentCards ? [this.user.personalPaymentCards] : [];
    } */
    this.user.paymentCards = this.user.paymentCards.filter(c => c?.token);

    if ((!this.user.paymentCards || this.user.paymentCards.length === 0) /* && (!this.user.personalPaymentCards || this.user.personalPaymentCards.length === 0) */) {
      this.translate
        .get(["common.no-card-user-error"])
        .pipe(take(1))
        .subscribe((value) =>
          this.ngxToastrService.typeInfo(
            null,
            value["common.no-card-user-error"]
          )
        );
      return Promise.resolve(null);
    }

    const defaultToken = this.company?.cardRedsys?.find(c => c?.isDefault && c?.token)?.token || null;

    if (defaultToken) {
      this.user.paymentCards = [
        ...this.user.paymentCards.filter(c => c.token === defaultToken),
        ...this.user.paymentCards.filter(c => c.token !== defaultToken),
      ];
    }

    return new Promise((resolve) => {
      const modalRef = this.modalService.open(UserCardModalComponent, {
        windowClass: 'custom-modal-user-card',
        centered: true,
        backdrop: 'static',
        keyboard: false
      });
      modalRef.componentInstance.company = this.company;
      modalRef.componentInstance.bookCards = this.user.paymentCards;
      /* modalRef.componentInstance.bookPersonalCards = this.user.personalPaymentCards; */
      modalRef.componentInstance.fromBookSelect = true;
      modalRef.componentInstance.cardSelected.subscribe((selectedCard) => {
        resolve(selectedCard);
      });
      modalRef.result.catch(() => {
        resolve(null);
      });
    });
  }

  handleTravel(dataTravel: any) {
    this.bodyTravel = dataTravel;
    this.travelUtilsService.setTravelLocalStorage(this.bodyTravel);
    this.translate.get(["project.form.saved"]).subscribe((resp) => {
      this.ngxToastrService.typeSuccess(resp["project.form.saved"], "");
    });
  }
  closeModal() {
    this.activeModal.dismiss("Cross click");
  }

  loadGroups(uuid) {
    this.loading = true;
    this.groupService.getGroups(uuid).subscribe(
      (result: any[]) => {
        this.loading = false;
        result
          .filter((group) =>
            this.type?.toLowerCase() === "flight"
              ? group.filters.requestFlight
              : group.filters.requestTrain
          )
          .forEach((group) => (this.users = this.users.concat(group.users)));
      },
      (err) => {
        this.loading = false;
        this.translate
          .get(`${this.type?.toLowerCase()}.create-${this.type?.toLowerCase()}.error-load-employees`)
          .subscribe((result) => {
            this.ngxToastrService.typeInfo(result, err.error.error);
          });
      }
    );
  }

  // Buscador de ciudades
  getCities(value: string) {
    this.citiesList = [];
    if (value !== "" && value.length > 2) {
      cities.Table1.forEach((v) => {
        if (
          v["name"]?.toLowerCase().includes(value?.toLowerCase()) &&
          !this.citiesList.includes(v.name)
        ) {
          this.citiesList.push(v["name"]);
        }
      });
    } else {
      this.citiesList = [];
    }
  }

  cleanCitiesList() {
    this.citiesList = [];
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0 && this.userType === 'EMPLOYEE') {
      for (let i = 0; i < event.target.files.length; i++) {
        this.files.push(event.target.files[i]);
      }
    }
  }

  removeFile(index: number) {
    const fileToRemove = this.existingFiles[index] || this.files[index];
    if (fileToRemove.url) {
      this.filesToRemove.push(fileToRemove.url);
      this.existingFiles.splice(index, 1);
    } else {
      this.files.splice(index, 1);
    }
  }

  getOutDate() {
    return this.f.dateDeparture
      ? this.f.dateDeparture.value
      : this.minDateNgStruct;
  }

  returnTrip(type) {
    this.checkedOneWay = type === "oneWay";
    this.checkedReturn = type === "return";
    const validator = this.checkedOneWay ? null : [Validators.required];
    this.form.get("dateReturn").setValidators(validator);
    this.form.get("timeReturn").setValidators(validator);
    this.form.get("dateReturn").updateValueAndValidity();
    this.form.get("timeReturn").updateValueAndValidity();
    const returnCarrierKey = this.type === "flight" ? 'returnAirline' : 'returnCarrier';
    const returnCarrierControl = this.form.get(returnCarrierKey);
    if (returnCarrierControl) {
      this.checkedOneWay ? returnCarrierControl.disable() : returnCarrierControl.enable();
    }

    const seatsReturnCtrl = this.form.get('seatsReturn');
    if (seatsReturnCtrl) {
      if (this.checkedOneWay) {
        seatsReturnCtrl.disable();
        seatsReturnCtrl.setValue('');
      } else {
        seatsReturnCtrl.enable();
      }
    }

    const travellersArray = this.form.get('travellers') as FormArray;
    if (travellersArray?.controls?.length) {
      travellersArray.controls.forEach(g => {
        const c = g.get('seatReturn');
        if (!c) return;
        if (this.checkedOneWay) {
          c.disable();
          c.setValue('');
        } else {
          c.enable();
        }
      });
    }

    const retFA = this.form.get('returnLegs') as FormArray;
    if (retFA) {
      if (this.checkedOneWay) retFA.clear();
      if (!this.checkedOneWay && retFA.length === 0) {
        const legsRet = this.buildLegsFromScales('return');
        legsRet.forEach(l => retFA.push(this.formBuilder.group({
          segment: [l.segment],
          departure: [l.departure],
          arrival: [l.arrival],
          type: [l.type],
          seat: ['']
        })));
      }
    }
  }

  getCompanyUsers(updateForm: boolean = false, callback?: Function) {
    this.companyService.getCompanyUsers(this.companyUuid).subscribe(
      (res) => {
        this.companyUsers = res.map(user => ({
          name: user.name,
          lastname: user.lastname,
          uuid: user.uuid
        }));
        this.filteredUsers = [...this.companyUsers];
        this.filteredUsersWithoutDefault = this.filteredUsers.filter(user => user.uuid !== this.defaultUser?.uuid);
  
        if (updateForm && this.data) {
          this.form.patchValue({
            passenger: this.data.userUuid
          });
        }
        if (callback) {
          callback();
        }
      },
      (err) => {}
    );
  }

  updateTravellers() {
    if(this.request){
      const travellersArray = this.form.get('travellers') as FormArray;
      const incomingTravellers = this.request?.travellers ?? [];
      const travellersCount = incomingTravellers.length > 0
        ? incomingTravellers.length
        : this.form.get('travellersCount').value;
    
      if (incomingTravellers.length > 0) {
        this.form.get('travellersCount').setValue(travellersCount);
      }
      travellersArray.clear();
      for (let i = 0; i < travellersCount; i++) {
        const t = incomingTravellers[i];
        travellersArray.push(this.formBuilder.group({
          uuid: [t ?? (i === 0 ? this.defaultUser?.uuid : null), Validators.required],
          price: [t?.price ?? '', Validators.required],
          wholesalePrice: [t?.wholesalePrice ?? ''],
          files: [t?.files ?? []],
          class: [t?.class ?? ''],
          extras: [t?.extras ?? ''],
          provider: [t?.provider ?? ''],
          freeTaxes: [t?.freeTaxes ?? false, Validators.required],
          seatOutbound: [t?.seatOutbound ?? ''],
          seatReturn:   [t?.seatReturn ?? ''],
        }));
      }
    } else {
      if (!this.editing && this.request?.travellers && this.request.travellers.length > 0) {
        this.form.get('travellersCount').setValue(this.request.travellers.length);
      }
      const travellersArray = this.form.get('travellers') as FormArray;
      const travellersCount = this.form.get('travellersCount').value;
      travellersArray.clear();
      for (let i = 0; i < travellersCount; i++) {
        travellersArray.push(this.formBuilder.group({
          uuid: [i === 0 ? this.defaultUser?.uuid || null : null, Validators.required],
          price: ['', Validators.required],
          wholesalePrice: [''],
          files: [[]],
          class: [''],
          extras: [''],
          provider: [''],
          freeTaxes: [false, Validators.required],
          seatOutbound: [''],
          seatReturn:   [''],
        }));
      }
    }
  }
  
  onFileChangeTraveller(event: any, index: number) {
    const files: File[] = Array.from(event.target.files);
    const travellersArray = this.form.get('travellers') as FormArray;
    const control = travellersArray.at(index).get('files');
    const existingFiles = control.value || [];
    control.setValue(existingFiles.concat(files));
  }

  removeFileCustom(travellerIndex: number, fileIndex: number) {
    const travellersArray = this.form.get('travellers') as FormArray;
    const files = travellersArray.at(travellerIndex).get('files').value as File[];
    files.splice(fileIndex, 1);
    travellersArray.at(travellerIndex).get('files').setValue([...files]);
  }
  
  compareUsersByUuid = (uuid1: string, uuid2: string): boolean => {
    return uuid1 === uuid2;
  };
  
  getUserObject(uuid: string) {
    return  uuid ;
  }

  private loadProvidersForType(type: 'flight' | 'train'): void {
    if (!type) return;
    this.loadingProviders = true;
    this.providersService.getProviders(type as ProviderType).subscribe({
      next: (items) => {
        const docs = items || [];
        this.providerDocsMap[type] = docs;

        const names = docs
          .map(i => (i?.name || '').trim())
          .filter(Boolean);

        const ensure = (val?: string) => {
          const v = (val || '').trim();
          if (!v) return;
          if (!names.some(n => n.toLowerCase() === v.toLowerCase())) {
            names.unshift(v);
          }
        };

        ensure(this.form?.get('provider')?.value);

        const trav = this.form?.get('travellers') as FormArray;
        if (trav?.controls?.length) {
          trav.controls.forEach(ctrl => ensure(ctrl.get('provider')?.value));
        }

        this.providerOptionsMap[type] = names;
        this.loadingProviders = false;
      },
      error: () => {
        this.providerOptionsMap[type] = [];
        this.loadingProviders = false;
      }
    });
  }

  private resolveProviderUuidByName(name?: string | null): string | null {
    if (!name || !this.type) return null;

    const docs = this.providerDocsMap[this.type] || [];
    const target = name.toString().trim().toLowerCase();

    const found = docs.find((p: any) =>
      (p.name && p.name.toString().trim().toLowerCase() === target) ||
      (p.nameNormalized && p.nameNormalized.toString().trim().toLowerCase() === target)
    );

    return found?.uuid ?? null;
  }

  getCurrentProviderOptions(): string[] {
    return this.type ? this.providerOptionsMap[this.type] : [];
  }

  providerCompare = (a: any, b: any) =>
    (a ?? '').toString().trim().toLowerCase() === (b ?? '').toString().trim().toLowerCase();

  private normalizeProvider(v: any): string {
    const val = (v ?? '').toString().trim();
    return val;
  }

  private parseSeats = (v: string): string[] =>
    (v || '').split(',').map(s => s.trim()).filter(Boolean);

  private buildSeatObjects(
    seats: string[],
    segmentLabel: 'outbound' | 'return' | string,
    departure: string,
    arrival: string
  ) {
    return seats.map(seat => ({
      seat,
      segment: segmentLabel,
      type: segmentLabel === 'outbound' || segmentLabel === 'return' ? segmentLabel : undefined,
      departure,
      arrival,
    }));
  }

  private getSeatsArray(): Array<{departure:string; arrival:string; segment?:string; type?:string; seat?:string}> {
    return (this.data?.extraInfo?.[0]?.seats as any[])?.length
      ? (this.data.extraInfo[0].seats as any[])
      : ((this.data?.seats as any[]) || []);
  }

  private buildLegsFromScales(direction: 'outbound' | 'return') {
    const norm = (v: string) => (v || '').trim().toUpperCase();

    const layovers = (this.data?.scales || [])
      .find(s => s.type === direction)?.layovers || [];

    if (!layovers.length) {
      const seats = this.getSeatsArray() || [];

      if (seats.length === 2) {
        const [a, b] = seats;
        const isReverse = a?.departure && a?.arrival && b?.departure && b?.arrival &&
                          norm(a.departure) === norm(b.arrival) &&
                          norm(a.arrival)   === norm(b.departure);

        if (isReverse) {
          if (direction === 'outbound') {
            return [{ segment: a.segment || '', departure: a.departure, arrival: a.arrival, type: 'outbound' }];
          } else {
            return [{ segment: b.segment || '', departure: b.departure, arrival: b.arrival, type: 'return' }];
          }
        }
      }

      const typed = seats.find(s => (s.type || '').toLowerCase() === direction);
      if (typed) {
        return [{
          segment:   typed.segment || '',
          departure: typed.departure,
          arrival:   typed.arrival,
          type:      direction,
        }];
      }

      const origin = direction === 'outbound' ? this.data?.from : this.data?.to;
      const dest   = direction === 'outbound' ? this.data?.to   : this.data?.from;
      return (origin && dest && norm(origin) !== norm(dest))
        ? [{ segment: '', departure: origin, arrival: dest, type: direction }]
        : [];
    }

    const firstFrom = layovers[0].from ?? layovers[0].origin;
    const globalOrigin = direction === 'outbound' ? this.data?.from : this.data?.to;

    const legs: Array<{segment:string; departure:string; arrival:string; type:'outbound'|'return'}> = [];

    if (globalOrigin && norm(globalOrigin) !== norm(firstFrom)) {
      legs.push({ segment: '', departure: globalOrigin, arrival: firstFrom, type: direction });
    }

    for (const l of layovers) {
      legs.push({
        segment: l.flightNumber || '',
        departure: l.from ?? l.origin,
        arrival: l.to ?? l.destination,
        type: direction,
      });
    }

    const saved = this.getSeatsArray();
    for (const leg of legs) {
      if (!leg.segment) {
        const match = saved.find(s => s.departure === leg.departure && s.arrival === leg.arrival && s.segment);
        if (match?.segment) leg.segment = match.segment;
      }
    }
    return legs;
  }

  private preloadSeatForLeg(leg: { departure: string; arrival: string; type: 'outbound'|'return'; segment?: string }) {
    const norm = (v: string) => (v || '').trim().toUpperCase();
    const isIata = (v: string) => /^[A-Z]{3}$/.test(norm(v));
    const seats = this.getSeatsArray() || [];

    if ((leg as any).segment) {
      const bySeg = seats.find(s => (s.segment || '').trim() === String((leg as any).segment).trim());
      if (bySeg?.seat) return bySeg.seat;
    }

    const byPair = seats.find(s => norm(s.departure) === norm(leg.departure) && norm(s.arrival) === norm(leg.arrival));
    if (byPair?.seat) return byPair.seat;

    if (!isIata(leg.departure)) {
      const candidates = seats.filter(s => norm(s.arrival) === norm(leg.arrival) && (s.type || '').toLowerCase() === leg.type);
      if (candidates.length === 1 && candidates[0]?.seat) return candidates[0].seat;
    }

    const sameDir = (this.data?.scales || []).find(x => x.type === leg.type)?.layovers || [];
    const globalOrigin = leg.type === 'outbound' ? this.data?.from : this.data?.to;
    const firstFrom    = sameDir?.[0]?.from ?? sameDir?.[0]?.origin;
    const addBridge    = sameDir.length > 0 && globalOrigin && norm(globalOrigin) !== norm(firstFrom) ? 1 : 0;
    const legsCount    = sameDir.length ? sameDir.length + addBridge : 1;

    if (legsCount === 1) {
      const loose = seats.filter(s =>
        norm(s.departure) === norm(leg.departure) ||
        norm(s.arrival)   === norm(leg.arrival)
      );
      if (loose.length === 1 && loose[0]?.seat) return loose[0].seat;

      if (seats.length === 2) {
        const [a, b] = seats;
        if (norm(a.arrival) === norm(leg.arrival) && a.seat) return a.seat;
        if (norm(b.arrival) === norm(leg.arrival) && b.seat) return b.seat;
      }
    }

    return '';
  }

  applyFilter(filterValue: string) {
    this.filteredUsers = this.companyUsers.filter(user =>
      `${user.name} ${user.lastname}`.toLowerCase().includes(filterValue.toLowerCase())
    );
  }

  onSelectToggle(opened: boolean) {
  if (!opened) {
      this.filteredUsers = [... this.companyUsers];
    }
  }
}
